import React from 'react';
import { Image } from '@frontend-monorepo/cyolo-ui';
import { makeAutoObservable } from 'mobx';
import axios from '@frontend-monorepo/http-client';
import { Store } from '@frontend-monorepo/cyolo-store';

var CompanyLogoSvg = 'data:image/svg+xml;base64,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';

var BlueCompanyLogoSvg = 'data:image/svg+xml;base64,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';

var WhiteCompanyLogoSvg = 'data:image/svg+xml;base64,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';

var appIcon = {
  height: '26px',
  width: '83px'
};
var styles = {
  appIcon: appIcon
};

var CompanyLogo = function CompanyLogo(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'regular' : _ref$type,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
  var svg;

  switch (type) {
    case 'regular':
      svg = CompanyLogoSvg;
      break;

    case 'white':
      svg = WhiteCompanyLogoSvg;
      break;

    case 'blue':
      svg = BlueCompanyLogoSvg;
      break;

    default:
      svg = CompanyLogoSvg;
      break;
  }

  return /*#__PURE__*/React.createElement(Image, {
    alt: "an application icon",
    style: Object.assign(Object.assign({}, styles.appIcon), style),
    src: svg
  });
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

var CompanyInfo = /*#__PURE__*/function () {
  function CompanyInfo() {
    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var welcomeMessage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var icon = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    var personalDesktopMessage = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
    var serversWatermark = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
    var adminConsoleLogo = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';
    var headerPlaceHolder = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
    var legalDocTitle = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : '';
    var legalDocBody = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : '';

    _classCallCheck(this, CompanyInfo);

    this.id = id;
    this.name = name;
    this.welcomeMessage = welcomeMessage;
    this.icon = icon;
    this.personalDesktopMessage = personalDesktopMessage;
    this.serversWatermark = serversWatermark;
    this.adminConsoleLogo = adminConsoleLogo;
    this.headerPlaceHolder = headerPlaceHolder;
    this.legalDocTitle = legalDocTitle;
    this.legalDocBody = legalDocBody;
    makeAutoObservable(this, {}, {
      autoBind: true
    });
  }
  /**
   * returns if an icon exits
   */


  _createClass(CompanyInfo, [{
    key: "iconExists",
    get: function get() {
      if (this.icon === '' || this.icon === undefined) {
        return false;
      }

      return true;
    }
    /**
     * returns if servers watermark exists
     */

  }, {
    key: "serversWatermarkExists",
    get: function get() {
      if (this.serversWatermark === '' || this.serversWatermark === undefined) {
        return false;
      }

      return true;
    }
    /**
     * returns if admin console logo exists.
     */

  }, {
    key: "adminConsoleLogoExists",
    get: function get() {
      return Boolean(this.adminConsoleLogo);
    }
  }, {
    key: "toRaw",
    value: function toRaw() {
      var welcomeMessage = this.welcomeMessage,
          personalDesktopMessage = this.personalDesktopMessage,
          headerPlaceHolder = this.headerPlaceHolder,
          legalDocTitle = this.legalDocTitle,
          legalDocBody = this.legalDocBody;
      return {
        welcome_message: welcomeMessage,
        personal_desktop_message: personalDesktopMessage,
        header_placeholder: headerPlaceHolder,
        legal_doc_title: legalDocTitle,
        legal_doc_body: legalDocBody
      };
    }
  }], [{
    key: "fromRaw",
    value: function fromRaw(obj) {
      var id = obj.id,
          name = obj.name,
          welcome_message = obj.welcome_message,
          icon = obj.icon,
          personal_desktop_message = obj.personal_desktop_message,
          servers_watermark = obj.servers_watermark,
          admin_console_logo = obj.admin_console_logo,
          header_placeholder = obj.header_placeholder,
          legal_doc_title = obj.legal_doc_title,
          legal_doc_body = obj.legal_doc_body;
      return new CompanyInfo(id, name, welcome_message, icon, personal_desktop_message, servers_watermark, admin_console_logo, header_placeholder, legal_doc_title, legal_doc_body);
    }
  }]);

  return CompanyInfo;
}();

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

var Endpoints;

(function (Endpoints) {
  Endpoints["GetCompanyInfo"] = "/v1/company/info";
  Endpoints["UpdateCompanyInfo"] = "/v1/company/info";
})(Endpoints || (Endpoints = {}));

var Endpoints$1 = Endpoints;

var getCompanyInfo = function getCompanyInfo() {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var _yield$axios$get, data;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return axios.get(Endpoints$1.GetCompanyInfo);

          case 2:
            _yield$axios$get = _context.sent;
            data = _yield$axios$get.data;
            return _context.abrupt("return", data);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};

var updateCompanyInfo = function updateCompanyInfo(companyInfo) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return axios.post(Endpoints$1.UpdateCompanyInfo, companyInfo.toRaw());

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
};

var CompanyAPI = {
  getCompanyInfo: getCompanyInfo,
  updateCompanyInfo: updateCompanyInfo
};

var CompanyInfoStore = /*#__PURE__*/function (_Store) {
  _inherits(CompanyInfoStore, _Store);

  var _super = _createSuper(CompanyInfoStore);

  function CompanyInfoStore() {
    var _this;

    _classCallCheck(this, CompanyInfoStore);

    return _this = _super.call(this, 'company_info', function () {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = CompanyInfo;
                _context.next = 3;
                return CompanyAPI.getCompanyInfo();

              case 3:
                _context.t1 = _context.sent;
                return _context.abrupt("return", _context.t0.fromRaw.call(_context.t0, _context.t1));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }, new CompanyInfo());
  }

  return CompanyInfoStore;
}(Store);

export { CompanyAPI, CompanyInfo, CompanyInfoStore, CompanyLogo };
//# sourceMappingURL=index.es.js.map
